import React from 'react';

import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';

import { Loading } from 'Components/Partials';

import PollsApi from 'Services/Api/Admin/MainStage/Polls';

import { Socket } from 'Services';

ChartJS.register(...registerables);

const options = {
    indexAxis: 'y',
    scales: {
        y: {
            grid: {
                borderColor: '#0D1846',
            },
            ticks: {
                beginAtZero: true,
                color: '#0D1846',

            },
        },
        x: {
            grid: {
                borderColor: '#0D1846',
            },
            max: 1,
            ticks: {
                color: '#0D1846',
                callback: function (value) {
                    return value.toLocaleString('en-UK', { style: 'percent' });
                },
            },
        },
    },
    animation: false,
    color: '#0D1846',
};

export default class PollResultsGraph extends React.Component {
    /**
     * @var bgs
     * @type {array}
     */
    bgs = [
        'bg-app-blue-dark',
        'bg-app-red',
        'bg-app-orange',
        'bg-app-green',
    ];

    /**
     * @var colors
     * @type {array}
     */
    colors = [
        '#8A3FF5',
        '#EC8938',
    ];

    /**
     * @var state
     */
    state = {
        loading: true,
        poll: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        this.handleOpenPoll(this.props.poll_id);
    };

    /**
     * @method componentDidUpdate
     * @param prevProps
     */
    componentDidUpdate = async (prevProps) => {
        if (this.props.poll_id !== prevProps.poll_id) {
            this.handleClosePoll(prevProps.poll_id);

            this.handleOpenPoll(this.props.poll_id);
        }
    }

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.handleClosePoll(this.props.poll_id);
    };

    /**
     * @method handleOpenPoll
     * @params {poll_id}
     */
    handleOpenPoll = async (poll_id) => {
        if (poll_id) {
            this.setState({ loading: true });

            const request = await PollsApi.get({
                session: this.props.session_id,
                poll: poll_id
            });

            if (request.success) {
                this.setState({
                    loading: false,
                    poll: request.data.data
                });
            }

            Socket.getConnection()
                .private(`main_stage_sessions.polls.${poll_id}`)
                .listen('MainStagePollAnswered', this.handleUpdatePoll);
        }
    }

    /**
     * @method handleClosePoll
     * @params {poll_id}
     */
    handleClosePoll = (poll_id) => {
        if (poll_id) {
            Socket.getConnection()
                .leave(`main_stage_sessions.polls.${poll_id}`);
        }
    }

    /**
     * @method handleUpdatePoll
     */
    handleUpdatePoll = (e) => {
        const poll = this.state.poll;

        if (poll && poll.id === e.poll_id) {
            const index = poll.answers.findIndex(answer => e.answer_id === answer.id);

            poll.answers[index].submission_count = e.answer_submission_count;

            this.setState({
                poll
            });
        }
    }

    /**
     * @method getGraphData
     */
    getGraphData = () => {
        const { poll } = this.state;

        const total = poll.answers.reduce((acc, answer) => acc + answer.submission_count, 0);

        return (
            {
                labels: poll.answers.map(a => {
                    let answer = a.answer.substring(0, 47);
                    if (answer !== a.answer) {
                        answer += '...';
                    }

                    return this.wordWrap(answer, { width: 25 })
                }),
                datasets: [
                    {
                        label: '% of Votes',
                        data: poll.answers.map(a => (a.submission_count / total)),
                        borderWidth: 1,
                        backgroundColor: '#1C79BE',
                    },
                ],
            }
        )
    };

    /**
     * @method getTitle
     */
    getTitle = () => {
        const { poll } = this.state;

        return (
            {
                plugins: {
                    title: {
                        display: true,
                        text: poll.question,
                        color: '#0D1846',
                        font: {
                            size: 18,
                        },
                    },
                },
            }
        );
    }

    /**
     * @method getTitle
     * @param {string} str
     * @param {object} options
     * @return {array}
     */
    wordWrap = (str, options) => {
        options = options || {};

        if (str == null) {
            return str;
        }

        const width = options.width || 50;

        let regexString = '.{1,' + width + '}';

        if (options.cut !== true) {
            regexString += '([\\s\u200B]+|$)|[^\\s\u200B]+?([\\s\u200B]+|$)';
        }

        const re = new RegExp(regexString, 'g');

        return str.match(re) || [];
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { loading, poll } = this.state;

        return (
            <div className="pb-3">
                {(loading || !poll) && (<Loading />)}

                {!loading && poll &&
                    <div
                        key={poll.id}
                        className="max-w-2xl mx-auto text-white bg-white text-xl mt-6 mb-3 rounded-xl"
                    >
                        <div className="px-4 py-2">
                            <div className={
                                `p-3  ${this.bgs[0]}`
                            }>
                                <Bar
                                    data={this.getGraphData()}
                                    options={{ ...options, ...this.getTitle() }}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
